<template>
  <div>
    <v-progress-linear v-if="loading" indeterminate></v-progress-linear>
    <AccountantsTotals :from="from"
                       :to="to"
                       :key="from+to"
                       :accountantId="0"/>
    <v-layout v-if="!$root.isMobile">
      <!--<v-flex shrink class="pl-2">
        <v-switch dense v-model="showAllSwitch" @change="fetchData" inset label="Show all"/>
      </v-flex>-->
      <v-flex grow class="pt-3">
        <v-text-field dense outlined class="ml-2 mr-2"
                      prepend-inner-icon="mdi-magnify"
                      placeholder="Start typing to filter dispatcher by name"
                      v-model="search"/>
      </v-flex>
    </v-layout>
    <v-data-table
      v-if="!$root.isMobile"
      :headers="headers"
      :items="items"
      height="calc(100vh - 300px)"
      fixed-header
      dense
      :items-per-page="-1"
      hide-default-footer
      @click:row="onReportSubTypeChanged('/reports/accountants/' + $event.id)"
    >
      <template v-slot:top>
        <v-toolbar flat :style="{ backgroundColor: $root.currentTheme.background }">
          {{$t('Reports.AccountantsTotals')}}
        </v-toolbar>
      </template>
      <template v-slot:item.accountant="{ item }">
        {{item.accountant}}
      </template>
      <template v-slot:item.invoicesCount="{ item }">
        {{item.invoicesCount}}
      </template>
      <template v-slot:item.totalAmount="{ item }">
        {{$root.moneyValue(item.totalAmount, 0)}}
      </template>
      <template v-slot:item.totalAccountantsFlatRate="{ item }">
        {{$root.moneyValue(item.totalAccountantsFlatRate, 0)}}
      </template>
      <template v-slot:item.totalAccountantsPercentRate="{ item }">
        {{$root.moneyValue(item.totalAccountantsPercentRate, 0)}}
      </template>
      <template v-slot:item.totalAccountantsRate="{ item }">
        <v-chip small color="success">{{$root.moneyValue(item.totalAccountantsRate,0)}}</v-chip>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import reportsMixin from '../../mixins/reportsMixin.js';
import AccountantsTotals from './AccountantsTotals.vue';
export default {
  name: 'AccountantsTotalsList',
  props: ['to', 'from'],
  mixins: [ reportsMixin ],
  components: {
    AccountantsTotals
  },
  data: function () {
    return {
      loading: false,
      items: [],
      totalsCounts: {},
      search: '',
      headers: [
        { text: 'Accountant', value: 'accountant' },
        { text: 'Invoices', value: 'invoicesCount' },
        { text: 'Amount', value: 'totalAmount' },
        { text: 'Flat Rate', value: 'totalAccountantsFlatRate' },
        { text: 'Precent Rate', value: 'totalAccountantsPercentRate' },
        { text: 'Salary', value: 'totalAccountantsRate' },
        { text: '', value: 'actions', sortable: false }
      ]
    };
  },
  computed: {
    filteredItems () {
      if (this.search.length === 0) {
        return Object.values(this.items);
      }
      return Object.values(this.items).filter((item) => {
        return item.accountant.toLowerCase().match(this.search);
      });
    }
  },
  mounted () {
    this.setAccountantsTotalsHeaders();
    this.fetchData();
  },
  methods: {
    onReportSubTypeChanged (path) {
      this.$root.setLocalStorageItem('reportTypePath', path);
      this.$root.route(path);
    },
    async fetchData () {
      let i = 0;
      let accountants = [];
      let dataResponse = {};
      let usersResponse = {};
      if (!this.from || !this.to) return;
      this.loading = true;
      // Get total miles
      this.items = [];
      usersResponse = await this.$root.loadUsersList(this.$store.getters.roleAccountingManager, false, true);
      if (usersResponse.status === 'ok') {
        accountants = usersResponse.result.data;
      }
      // Calc totals only for a big screen
      if (!this.$root.isMobile) {
        for (i = 0; i < accountants.length; i++) {
          dataResponse = await this.getAccountantsReportTotalData(this.from, this.to, accountants[i].id);
          if (dataResponse.status === 'ok') {
            this.items.push(dataResponse.results);
            this.items[this.items.length - 1].id = accountants[i].id;
            this.items[this.items.length - 1].accountant = accountants[i].firstName + ' ' + accountants[i].lastName;
          }
        }
      }
      this.loading = false;
    }
  }
};
</script>
